import { render, staticRenderFns } from "./ToolComponent.vue?vue&type=template&id=60cc12d3&scoped=true&"
import script from "./ToolComponent.vue?vue&type=script&lang=js&"
export * from "./ToolComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolComponent.vue?vue&type=style&index=0&id=60cc12d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc12d3",
  null
  
)

export default component.exports